import type { FormControlLabelProps } from '@mui/material/FormControlLabel'
import type { Theme } from '@mui/material/styles'
import type { SystemStyleObject } from '@mui/system'

/** Padding on Checkbox / Radio root */
export const selectionControlSx = (theme: Theme): SystemStyleObject<Theme> => ({
    padding: theme.spacing(0.5),
})

/** Shared label row for Checkbox / Radio via FormControlLabel */
export const selectionControlLabelProps: Pick<
    FormControlLabelProps,
    'sx' | 'slotProps'
> = {
    sx: {
        mb: 0,
        // MUI default is -11px; tighten to align with dense selection controls
        ml: '-6px',
    },
    slotProps: {
        typography: {
            sx: {
                fontSize: '0.875rem',
                color: 'text.primary',
            },
        },
    },
}
